import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      minHeight: '53vh',
      borderRadius: 20,
      overflow: 'hidden',
      boxShadow: '0 30px 80px rgba(15, 23, 42, 0.2)',
    },
    dialogTitle: {
      padding: 0,
      background:
        'radial-gradient(circle at top right, rgba(255,255,255,0.2), transparent 30%), linear-gradient(135deg, #072577 0%, #1d4ed8 55%, #60a5fa 100%)',
    },
    titleContent: {
      padding: theme.spacing(2.25, 3, 1.75),
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      gap: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    titleText: {
      flex: 1,
      minWidth: 0,
    },
    titleHeading: {
      color: '#f8fafc',
      fontWeight: 800,
      letterSpacing: '-0.03em',
    },
    titleSubtitle: {
      color: 'rgba(226, 232, 240, 0.84)',
      lineHeight: 1.65,
      maxWidth: 760,
    },
    titleActions: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    selectionBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      padding: theme.spacing(0.9, 1.5),
      borderRadius: 999,
      border: '1px solid rgba(255,255,255,0.14)',
      background:
        'linear-gradient(180deg, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0.08) 100%)',
      color: '#ffffff',
      fontSize: '0.82rem',
      fontWeight: 700,
      backdropFilter: 'blur(8px)',
    },
    closeButton: {
      color: '#ffffff',
      backgroundColor: 'rgba(255,255,255,0.12)',
      '&:hover': {
        backgroundColor: 'rgba(255,255,255,0.2)',
      },
    },
    content: {
      padding: theme.spacing(2.5, 3, 2),
      background:
        'linear-gradient(180deg, rgba(248,250,252,0.94) 0%, rgba(255,255,255,1) 100%)',
    },
    filterSurface: {
      // display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      gap: theme.spacing(2),
      padding: theme.spacing(1.5),
      marginBottom: theme.spacing(1.75),
      borderRadius: 20,
      background:
        'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.96) 100%)',
      border: '1px solid rgba(148, 163, 184, 0.18)',
      boxShadow: '0 20px 40px rgba(15, 23, 42, 0.08)',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'stretch',
      },
    },
    filterMeta: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
      minWidth: 0,
    },
    surfaceTitle: {
      fontWeight: 700,
      color: '#0f172a',
    },
    surfaceSubtitle: {
      color: '#64748b',
      lineHeight: 1.6,
    },
    filterContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      flexWrap: 'wrap',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    tableMeta: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: theme.spacing(2),
      marginBottom: theme.spacing(1.5),
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    countBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      padding: theme.spacing(0.85, 1.5),
      borderRadius: 999,
      fontSize: '0.82rem',
      fontWeight: 700,
      color: '#1d4ed8',
      background: 'rgba(219, 234, 254, 0.9)',
      border: '1px solid rgba(96, 165, 250, 0.35)',
    },
    tableSurface: {
      borderRadius: 14,
      overflow: 'hidden',
      background:
        'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.96) 100%)',
      border: '1px solid rgba(148, 163, 184, 0.18)',
      boxShadow: '0 20px 40px rgba(15, 23, 42, 0.08)',
    },
    tableHeadRow: {
      background: 'rgba(241, 245, 249, 0.9)',
    },
    tableHeadCell: {
      borderBottom: '1px solid rgba(148, 163, 184, 0.18)',
      color: '#ffffff',
      fontWeight: 800,
      fontSize: '0.78rem',
      textTransform: 'uppercase',
      letterSpacing: '0.08em',
      whiteSpace: 'nowrap',
    },
    resultRow: {
      '&:not(:last-child) td': {
        borderBottom: '1px solid rgba(226, 232, 240, 0.9)',
      },
      '&:hover': {
        background: 'rgba(248, 250, 252, 0.85)',
      },
    },
    pagination: {
      borderTop: '1px solid rgba(226, 232, 240, 0.9)',
      background: 'rgba(255,255,255,0.92)',
    },
    actions: {
      padding: theme.spacing(2, 3, 2),
      justifyContent: 'space-between',
      alignItems: 'center',
      background:
        'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(248,250,252,0.96) 40%)',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: theme.spacing(1),
      },
    },
    actionText: {
      color: '#64748b',
      fontSize: '0.88rem',
      lineHeight: 1.6,
      maxWidth: 460,
    },
    actionShell: {
      display: 'flex',
      gap: theme.spacing(1),
      padding: theme.spacing(0.75),
      borderRadius: 999,
      border: '1px solid rgba(148, 163, 184, 0.18)',
      background:
        'linear-gradient(135deg, rgba(255,255,255,0.94) 0%, rgba(248,250,252,0.88) 100%)',
      boxShadow: '0 16px 36px rgba(15, 23, 42, 0.08)',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    secondaryButton: {
      minHeight: 44,
      padding: theme.spacing(0, 2),
      borderRadius: 14,
      textTransform: 'none',
      fontWeight: 700,
      boxShadow: 'none',
      [theme.breakpoints.down('sm')]: {
        flex: 1,
      },
    },
    primaryButton: {
      minHeight: 44,
      padding: theme.spacing(0, 2.5),
      borderRadius: 14,
      textTransform: 'none',
      fontWeight: 700,
      background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 55%, #60a5fa 100%)',
      boxShadow: '0 14px 30px rgba(37, 99, 235, 0.24)',
      '&:hover': {
        background: 'linear-gradient(135deg, #1d4ed8 0%, #2563eb 55%, #3b82f6 100%)',
        boxShadow: '0 16px 34px rgba(37, 99, 235, 0.28)',
      },
      '&.Mui-disabled': {
        color: 'rgba(255,255,255,0.72)',
        background: 'linear-gradient(135deg, #93c5fd 0%, #60a5fa 100%)',
      },
      [theme.breakpoints.down('sm')]: {
        flex: 1,
      },
    },
    filterHeader: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: theme.spacing(2),
      marginBottom: theme.spacing(1.5),
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
  }),
);

export default useStyles;
